import { MediaType } from '@confluence/graphql/entry-points/MediaType';
import { useExperimentalMutation } from '@confluence/legacy-schema-bridge/entry-points/useExperimentalMutation';

import type {
	ExperimentalUpdateShortcuts as UpdateShortcutMutationData,
	ExperimentalUpdateShortcutsVariables as UpdateShortcutMutationVars,
} from './__types__/ExperimentalUpdateShortcuts';

export const useExperimentalUpdateShortcutLinksMutation = () => {
	return useExperimentalMutation<
		UpdateShortcutMutationData,
		UpdateShortcutMutationVars,
		UpdateShortcutLinksResponse
	>({
		url: '/wiki/rest/ia/1.0/link/batch',
		method: 'POST',
		body: (variables) => JSON.stringify(variables),
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: ({ quickLinks }) => {
			const links = quickLinks.map(({ id, position, styleClass, title, url }) => ({
				id: String(id),
				position: String(position),
				styleClass,
				title,
				url,
			}));

			return {
				experimentalUpdateShortcutLinks: {
					quickLinks: links,
					__typename: 'ExperimentalQuickLinks',
				},
			};
		},
	});
};

interface QuickLinkResponse {
	id: number;
	position: number;
	styleClass: string;
	title: string;
	url: string;
}

interface UpdateShortcutLinksResponse {
	quickLinks: QuickLinkResponse[];
}
